import { type SyntheticEvent, useState } from 'react';
import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { useNavigate } from '@/hooks/use-navigation';

const Icons = (
  searchValue: string,
  clearSearch: () => void,
  handleSearch: (e: SyntheticEvent) => void
) => (
  <InputAdornment position="end">
    {searchValue && (
      <IconButton onClick={clearSearch} edge="end" aria-label="Limpar pesquisa">
        <CloseRounded />
      </IconButton>
    )}
    <IconButton onClick={handleSearch} edge="end" aria-label="Buscar curso">
      <SearchRounded />
    </IconButton>
  </InputAdornment>
);

export const SearchInput = () => {
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  const clearSearch = () => setSearchValue('');

  const onSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    navigate(`/cursos/?terms=${searchValue}`);
  };

  return (
    <form onSubmit={onSubmit} style={{ width: '100%' }}>
      <OutlinedInput
        type="text"
        sx={{ width: { xs: '100%', sm: '230px' } }}
        placeholder="Buscar curso"
        endAdornment={Icons(searchValue, clearSearch, onSubmit)}
        onChange={(e) => setSearchValue(e.target.value)}
        value={searchValue}
      />
    </form>
  );
};
